import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography, Grid, CircularProgress, Divider, Button } from '@mui/material';
import { ThumbUp, ThumbDown, Person } from '@mui/icons-material';

import { getPendingUsersOrgs } from 'js/library/utils/API/getPendingUsersOrgs';
import { updatePendingUsersOrgs } from 'js/library/utils/API/updatePendingUsersOrgs';
import { findValueInArray } from 'js/library/utils/helpers';

export const PendingRequests = (orgId) => {
  const { t } = useTranslation();

  const id = orgId.id;
  const uId = orgId.uId;
  const [users, setUsers] = React.useState(null);

  function getUsers() {
    getPendingUsersOrgs(uId, id).then((result) => {
      setUsers(result.pendingUsers);
    });
  }

  function handleRequest(uId, action) {
    setUsers(false);
    updatePendingUsersOrgs(action, uId, id).then((resultUser) => {
      getUsers();
    });
  }

  if (users === null) getUsers();

  return (
    <div className="height-content">
      <Typography
        style={{ color: '#0089FF', cursor: 'pointer' }}
        variant="body2"
        onClick={() => orgId.handleEdit(null)}
      >
        {'<'} {t('organizations.return')}
      </Typography>

      <Grid container spacing={0} style={{ width: '100%' }}>
        <Grid size={{ sm: 2, xs: false }}></Grid>
        <Grid size={{ sm: 8, xs: 12 }} align="center">
          <Person style={{ fontSize: 100 }} color="secondary" />
          <Typography variant="h6" color="secondary" style={{ fontWeight: 'bolder' }}>
            Pedidos Pendentes
          </Typography>
        </Grid>
        <Grid size={{ sm: 2, xs: false }}></Grid>
      </Grid>

      <Divider style={{ margin: '30px 0px' }} />

      {!users ? (
        <div style={{ textAlign: 'center' }}>
          <CircularProgress />
        </div>
      ) : users.legth === 0 ? (
        <Typography variant="body1" color="primary">
          {t('organizations.no_pending_order')}
        </Typography>
      ) : users.length === 0 ? (
        <Typography variant="subtitle1" color="secondary">
          {t('organizations.no_pending_invite')}
        </Typography>
      ) : (
        users.map((user) => {
          return (
            <Grid container key={user.uId} spacing={0} style={{ width: '100%' }}>
              <Grid size={{ sm: 6, xs: 12 }}>
                <Typography variant="h6" color="primary">
                  <i>{user.name}</i>
                </Typography>

                <Typography variant="body2" color="secondary">
                  {t('organizations.phone_number')}{' '}
                  {findValueInArray(user.contactList, 'type', 'cellPhone').value}
                </Typography>

                <Typography variant="body2" color="secondary">
                  {t('organizations.triibo_code')} {user.triiboCode}
                </Typography>
              </Grid>
              <Grid size={{ sm: 6, xs: 12 }} align="right">
                <Button
                  style={{ marginRight: '4px' }}
                  variant="contained"
                  color="primary"
                  onClick={() => handleRequest(user.uId, 'approve')}
                  aria-label="Aceitar"
                >
                  <ThumbUp />
                </Button>

                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => handleRequest(user.uId, 'reject')}
                  aria-label="Recusar"
                >
                  <ThumbDown />
                </Button>
              </Grid>
            </Grid>
          );
        })
      )}
    </div>
  );
};
export default PendingRequests;
